import { useNavigation, useRoute } from '@react-navigation/native'
import { Button, Heading, Text, VStack } from 'native-base'
import { useEffect, useState } from 'react'
import FormLayout from '../../layouts/FormLayout'
import { useAuthContext } from '../../providers/AuthProvider'
import LoadingScreen from '../LoadingScreen'

const LoginCallbackScreen = () => {
  const route = useRoute()
  const code = route.params?.code
  const error = route.params?.error
  const errorDescription = route.params?.error_description
  const navigation = useNavigation()
  const { loginWithCode } = useAuthContext()
  const [errorMessage, setErrorMessage] = useState('')

  useEffect(() => {
    if (error) {
      setErrorMessage(
        error === 'unauthorized'
          ? 'You may have clicked on an old email, or your email may have expired.  Delete any old emails you have, click the link below, and try again.'
          : `${error} - ${errorDescription}`
      )
    } else if (code) {
      loginWithCode(code).catch(() => navigation.navigate('Landing'))
    } else {
      navigation.navigate('Landing')
    }
  }, [code])

  return (
    <>
      {errorMessage ? (
        <FormLayout bg="cabanaSand">
          <VStack h="100%" w="100%">
            <Heading fontSize="24px" mb="3" mt="3" color="primary.900">
              Something went wrong trying to log you in
            </Heading>
            <VStack>
              <Text color="error.900" fontSize="16px" my={6}>
                {errorMessage}
              </Text>
              <Button
                onPress={() => navigation.replace('Login')}
                testID="continue-log-in-button"
                variant="link">
                <Text color="secondary.600" underline>
                  Try again
                </Text>
              </Button>
            </VStack>
          </VStack>
        </FormLayout>
      ) : (
        <LoadingScreen />
      )}
    </>
  )
}

export default LoginCallbackScreen
